import { z } from 'zod';
// §8.2 Foto de maestros (`GET /sync/snapshot`). Tolerante (passthrough) para que el servidor pueda
// agregar campos sin romper versiones antiguas de la app.
const Uuid = z.string();
const Vigencia = z.tuple([z.string(), z.string().nullable()]);
export const PersonaSnapshot = z
    .object({
    persona_id: Uuid,
    rut: z.string(),
    nombre: z.string(),
    credencial_qr: z.string().nullable().optional(),
    credencial_nfc: z.string().nullable().optional(),
    vinculos: z
        .array(z
        .object({
        sociedad_id: Uuid,
        vinculo_id: Uuid.optional(),
        vigencia: Vigencia,
        jornada_diaria_horas: z.number().positive().optional(),
    })
        .passthrough())
        .default([]),
})
    .passthrough();
export const SociedadSnapshot = z.object({ sociedad_id: Uuid, nombre: z.string(), rut: z.string().optional() }).passthrough();
export const CuadrillaSnapshot = z
    .object({
    cuadrilla_id: Uuid,
    sociedad_id: Uuid,
    nombre: z.string(),
    integrantes: z.array(Uuid).default([]),
})
    .passthrough();
export const UbicacionSnapshot = z
    .object({
    ubicacion_id: Uuid,
    sociedad_id: Uuid.optional(),
    tipo: z.enum(['predio', 'cuartel', 'hilera']),
    padre_id: Uuid.nullable().optional(),
    codigo: z.string(),
    nombre: z.string(),
})
    .passthrough();
export const LaborSnapshot = z
    .object({
    labor_codigo: z.string(),
    nombre: z.string(),
    modalidad: z.enum(['trato', 'dia', 'hora', 'mixta']).default('trato'),
    unidad: z.string().nullable().optional(),
    exige_calidad: z.boolean().default(false),
    tope_diario: z.number().nullable().optional(),
    concepto_codigo: z.string().default('TRATO'),
})
    .passthrough();
export const TarifaSnapshot = z
    .object({
    tarifa_id: Uuid.optional(),
    tarifario_id: Uuid,
    tarifario_nombre: z.string().optional(),
    sociedad_id: Uuid.optional(),
    labor: z.string(),
    cuartel_id: Uuid.nullable().optional(),
    tipo_calculo: z.enum(['tarifa_unitaria', 'dia', 'hora', 'dia_meta']),
    parametros: z.record(z.string(), z.unknown()),
    vigencia: Vigencia,
})
    .passthrough();
export const SnapshotMaestros = z
    .object({
    maestro_version: z.number().int().nonnegative(),
    generado_en: z.string(),
    sociedades: z.array(SociedadSnapshot).default([]),
    cuadrillas: z.array(CuadrillaSnapshot).default([]),
    personas: z.array(PersonaSnapshot).default([]),
    ubicaciones: z.array(UbicacionSnapshot).default([]),
    labores: z.array(LaborSnapshot).default([]),
    unidades: z.array(z.unknown()).default([]),
    conversiones: z.array(z.unknown()).default([]),
    tarifas_resueltas: z.array(TarifaSnapshot).default([]),
    parametros: z
        .object({
        leyenda_comprobante: z.string().optional(),
        umbral_desfase_reloj_min: z.number().optional(),
    })
        .passthrough()
        .default({}),
})
    .passthrough();
// §8.4 Subida de fotos de calidad.
export const FotoSasInput = z.object({
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
    bytes: z.number().int().positive().max(1_000_000),
});
export const FotoSasRespuesta = z.object({
    url: z.string().url(), // SAS de solo escritura, 10 minutos
    blob_path: z.string(), // fotos/{tenant}/{yyyy}/{mm}/{sha256}.jpg
    expira_en: z.string(),
});
//# sourceMappingURL=snapshot.js.map